export default "* Ansigtsudtryk\n* Kropssprog\n* Ven\n";